import React from "react";
import { fetchList } from "../../actions/table";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DropdownItem } from "reactstrap";

// Components
import ReduxTable, { ReduxColumn } from "../../components/base/ReduxTable";
import PageTitle from "../../components/base/PageTitle";
import Page404 from "../Page404";
import MoreDropdown from "../../components/base/MoreDropdown";
import toast from "../../components/base/Toast";

import AddContactFormFieldModal from "./AddContactFormFieldModal";

// Helper
import {
  isLoggedIn,
  isSuperAdmin,
  isCompanyAdmin,
  isCompanyManager
} from "../../lib/helper";

//API call
import { apiClient } from "../../apiClient";

// Configs
import { endpoints } from "../../configs";
import { isBadRequest } from "../../common/http";

class ContactFormsFields extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortByOptions: [
        {
          value: "createdAt:DESC",
          label: "Most Recent"
        },
        {
          value: "field_name",
          label: "Field Name"
        }
      ]
    };
  }

  componentDidMount() {
    // Check is logged in user
    isLoggedIn();
  }

  componentDidUpdate() {
    // Check is logged in user
    isLoggedIn();
  }

  // Contact form field delete api call
  handleDelete = id => {
    return apiClient
      .delete(`${endpoints().contactForm}/deleteContactFormField/${id}`)
      .then(() => {
        this.props.actions.fetchList(
          "contactFormFields",
          `/v1/contactForm/${this.props.match.params.id}`
        );
      })
      .catch(error => {
        if (isBadRequest(error)) {
          let errorMessage;
          const errorRequest = error.response.request;
          if (errorRequest && errorRequest.response) {
            errorMessage = JSON.parse(errorRequest.response).message;
          }
          toast.error(error.response.data.message);
          console.error(errorMessage);
        }
      });
  };

  render() {
    if (
      !isSuperAdmin(this.props.roleId) &&
      !isCompanyAdmin(this.props.roleId) &&
      !isCompanyManager(this.props.roleId)
    ) {
      return <Page404 />;
    }

    const headerButton = (
      <div className="btn-wrapper pull-right no-gutters mt-n4">
        <AddContactFormFieldModal formId={this.props.match.params.id} />
      </div>
    );

    return (
      <>
        {/* /.page-heading */}
        <PageTitle label="Contact Form Fields" />
        {headerButton}
        <div className="mt-4 mb-5">
          <ReduxTable
            id="contactFormFields"
            showHeader
            searchPlaceholder="Search"
            apiURL={`/v1/contactForm/${this.props.match.params.id}`}
            newTableHeading
            sortByOptions={this.state.sortByOptions}
          >
            <ReduxColumn type="link" field="field_name" sortBy="field_name">
              Field Name
            </ReduxColumn>
            <ReduxColumn field="field_label" sortBy="field_label">
              Field Label
            </ReduxColumn>
            <ReduxColumn field="field_type" sortBy="field_type">
              Field Type
            </ReduxColumn>
            <ReduxColumn field="createdAt" sortBy="createdAt">
              Created
            </ReduxColumn>
            <ReduxColumn
              field="Action"
              disableOnClick
              renderField={row => (
                <div className="text-center landing-group-dropdown">
                  <MoreDropdown>
                    <DropdownItem
                      className={"text-danger"}
                      onClick={() => this.handleDelete(row.id)}
                    >
                      Delete
                    </DropdownItem>
                  </MoreDropdown>
                </div>
              )}
            >
              Action
            </ReduxColumn>
          </ReduxTable>
        </div>
      </>
    );
  }
}

// export default ContactFormsFields;
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchList }, dispatch)
  };
}

const mapStateToProps = state => {
  const { user } = state;

  const roleId = user && !user.isFetching ? user.roleId : "";

  return { roleId };
};

export default connect(() => {
  return mapStateToProps;
}, mapDispatchToProps)(ContactFormsFields);
